"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetCoolingOffLimit = exports.SetSessionLimit = exports.SetGameLimit = void 0;
var SetGameLimit_1 = require("./SetGameLimit");
Object.defineProperty(exports, "SetGameLimit", { enumerable: true, get: function () { return __importDefault(SetGameLimit_1).default; } });
var SetSessionLimit_1 = require("./SetSessionLimit");
Object.defineProperty(exports, "SetSessionLimit", { enumerable: true, get: function () { return __importDefault(SetSessionLimit_1).default; } });
var SetCoolingOffLimit_1 = require("./SetCoolingOffLimit");
Object.defineProperty(exports, "SetCoolingOffLimit", { enumerable: true, get: function () { return __importDefault(SetCoolingOffLimit_1).default; } });
